import { render, staticRenderFns } from "./RationPlan.vue?vue&type=template&id=87818fa8"
import script from "./RationPlan.vue?vue&type=script&lang=ts"
export * from "./RationPlan.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports